<div class="boxTyp4 p4-0xs mb-4 withBottomFur">
  <div class="container pd-0XS-LR">
    <h3 class="titleTyp3 reduceLineheight" markdown [data]="section5?.title"></h3>
    <div class="pt-2 fs-20 fw400 fs17-XS text-ctmDefaultTextDark text-center mw810 center mb-4 line-ht90" markdown [data]="section5?.content"></div>

    <div class="row pt-2">
      <div class="col-12 col-lg-6 mb-4">
        <div class="boxTyp2 p-4 h100 imageFour">
          <div class="boxWidth">
            <div class="titleTyp3 reduceInnerMargin2 reduceLineheight ctmDefaultText" markdown [data]="section5Tile1?.title"></div>
          </div>
          <div class="boxDescription lh-1" markdown [data]="section5Tile1?.content"></div>
          <!-- <button class="btn btn-secondary-link fs-17 ps-0" (click)="messagePopup('dashboard/dashboard-section5-tile1-modal.md')">
            How does it work?
          </button> -->
          <a id="EnergyComparison_YourEnergyDashboard_WaysToSaveOnYourBills_ReadOurEnergyGuide" class="btn btn-secondary-link fs-17 ps-0" href="https://www.comparethemarket.com/energy/" target="_blank">
            Read our energy guide
          </a>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="boxTyp2 p-4 mb-4 imageTwo">
          <div class="boxWidth">
            <div class="titleTyp3 reduceInnerMargin2 reduceLineheight ctmDefaultText" markdown [data]="section5Tile2?.title"></div>
            <div class="boxDescription lh-1" markdown [data]="section5Tile2?.content"></div>
            <button id="EnergyComparison_YourEnergyDashboard_WaysToSaveOnYourBills_ViewEnergySavingsTips" class="btn btn-secondary-link fs-17 ps-0" (click)="savingsTips()">
              View energy saving tips
            </button>
          </div>
        </div>
        <div class="boxTyp2 p-4 mb-4 imageOne">
          <div class="boxWidth">
            <div class="titleTyp3 reduceInnerMargin2 reduceLineheight ctmDefaultText" markdown [data]="section5Tile3?.title"></div>
            <div class="boxDescription lh-1" markdown [data]="section5Tile3?.content"></div>
            <button id="EnergyComparison_YourEnergyDashboard_WaysToSaveOnYourBills_CompareInsurance" class="btn btn-secondary-link fs-17 ps-0" (click)="compareInsurance()">
              Compare insurance
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>